const genExportChannelId = payload => {
    const {
        assetType,
        pptxMode = "static",
        presentationId,
        presentationLinkId,
        forPrinting
    } = payload;

    const printing = forPrinting ? "printing" : "no-printing";
    const linkId = presentationLinkId || "no-link-id";

    return `private-export-${assetType}-${pptxMode}@${presentationId}@${linkId}@${printing}`;
};

module.exports = genExportChannelId;
